export default __webpack_public_path__ + "images/1de42a172bf383d55f66c0e7a03e3bda-1_web_1919x543.jpg";